export default "__VITE_ASSET__da66b217__"